import { Link, type LinkProps } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { buttonVariants } from '@/components/ui/button';

/** A router link that looks like a small outline button, for a table's Actions column. */
export function LinkButton({
  children,
  ...props
}: Readonly<LinkProps & { children: ReactNode }>) {
  return (
    <Link
      {...props}
      className={buttonVariants({ variant: 'outline', size: 'sm' })}
    >
      {children}
    </Link>
  );
}
